/**
 * Validates a value is within a range
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {number} context.min The minimum value allowed. If undefined, no minimum is enforced.
 * @param {number} context.max The maximum value allowed. If undefined, no maximum is enforced.
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name numericRange
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  const { min, max } = context;
  if (min !== undefined && value < min) return Promise.resolve('value-too-low');
  if (max !== undefined && value > max) return Promise.resolve('value-too-high');
  return Promise.resolve(null);
}

module.exports = validate;